import { EFirstMessageActionTypes, IFirstMessageSentPayload } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const setFirstMessagePending = actionGenerator<EFirstMessageActionTypes.Pending>(
  EFirstMessageActionTypes.Pending,
);

export const setFirstMessageSent = actionGenerator<EFirstMessageActionTypes.Sent, IFirstMessageSentPayload>(
  EFirstMessageActionTypes.Sent,
);

export const setFirstMessageFailed = actionGenerator<EFirstMessageActionTypes.Failed>(EFirstMessageActionTypes.Failed);

export const setFirstMessageChatsBlocked = actionGenerator<EFirstMessageActionTypes.ChatsBlocked>(
  EFirstMessageActionTypes.ChatsBlocked,
);

export const setFirstMessageNeedCaptcha = actionGenerator<EFirstMessageActionTypes.NeedCaptcha>(
  EFirstMessageActionTypes.NeedCaptcha,
);

export const setFirstMessageNeedConfirmPhone = actionGenerator<EFirstMessageActionTypes.NeedConfirmPhone>(
  EFirstMessageActionTypes.NeedConfirmPhone,
);

export const setFirstMessageUserChatsDisabled = actionGenerator<EFirstMessageActionTypes.UserChatsDisabled>(
  EFirstMessageActionTypes.UserChatsDisabled,
);

export const setFirstMessageValidationError = actionGenerator<EFirstMessageActionTypes.ValidationError>(
  EFirstMessageActionTypes.ValidationError,
);
